'use strict';
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var food = {
    Drink: {
        Wine: {},
        Schnaps: {}
    },
    Fruit: {
        Red: {
            Cherry: {},
            Strawberry: {}
        },
        Yellow: {
            Banana: {},
            Pineapple: {}
        }
    }
};
var tree = document.querySelector('#tree');
function createTree(element, data) {
    var ul = document.createElement('ul');
    element.appendChild(ul);
    for(var key in data){
        var li = document.createElement('li');
        li.textContent = key;
        ul.appendChild(li);
        if (_type_of(data[key]) === 'object' && data[key] !== null && Object.keys(data[key]).length > 0) createTree(li, data[key]);
    }
}
createTree(tree, food);

//# sourceMappingURL=js_tree-from-object-DOM.6584b537.js.map
